import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=58258f28&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=58258f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58258f28",
  null
  
)

export default component.exports